module.exports = __webpack_public_path__ + "img/advertise.0b6992d8.png";